import { ReminderStatus, SessionStatus } from './sessions';
import { ReminderValue } from './user';

export enum LOADING_STATUS {
  IDLE = 'idle',
  LOADING = 'loading',
  SUCCESS = 'success',
  ERROR = 'error',
}

export enum Method {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
}

export enum HttpCodeSessionException {
  SESSION_LIMIT = 2002,
  SESSION_IS_STARTED = 2003,
  SESSION_SLOT = 2004,
  SESSION_NO_SLOT = 2009,
}

export enum HttpCodeUserException {
  USER_NOT_FOUND = 1001,
}

export type TGetLikeDislikesResponse = {
  like: string[];
  dislike: string[];
  mostLiked: { insights: string[] };
};

export type TSessionMetadata = {
  created_by?: 'user' | 'stylist';
  platform_created?: 'lumi_web';
  platform_started?: 'lumi_web';
  platform_completed?: 'lumi_web';
};

export enum EStrapiApi {
  ARTICLE = '/articles',
  HIGHLIGHTS = '/highlights',
  STYLE_ARTICLE = '/style-articles',
  LEGAL_SENTENCE = '/legal-sentences',
  STYLIST = '/stylists',
  COLLECTIONS = '/collections',
  CATEGORIES = '/categories',
  HOME_INSIGHTS_CATEGORIES = '/home-insights-categories',
  PERSONALIZED_INSIGHTS_CATEGORIES = '/personalized-insights-categories',
  TAGS = '/tags',
  STYLING_JOURNEY = '/styling-journey',
  PERSONALISED_STYLING_JOURNEYS = '/personalised-styling-journeys',
}

export interface ICreateSessionData {
  timestamp: number;
  phone?: string;
  userName?: string;
  userId: string;
  reminderType: ReminderValue;
  secondsFromUtc: number;
  sessionType?: string;
  metadata: TSessionMetadata;
}

export type TCompletedStepRecord = {
  id: string;
  userId: string;
  journeyStep: string;
  createdAt: string;
};

export interface IEditSessionData {
  stylistId?: string;
  timestamp?: number;
  reminderType?: ReminderValue;
  reminderStatus?: ReminderStatus;
  status?: SessionStatus;
  secondsFromUtc?: number;
  metadata?: TSessionMetadata;
  endTimestamp?: number;
}
